import { useState } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import { toast } from "react-toastify"
import instance from "../../../../../axios/instance"

export default function GuestSetUp() {

    const [user, setUser] = useState("")
    const [error, setError] = useState("")
    const location = useLocation()
    const [loading, setLoading] = useState(false)
    const navigate = useNavigate()

    function joinMeeting() {
        setError("")
        setLoading(true)
        if (!user) {
            setError("Input field can not be empty")
            setLoading(false)
        } else {
            const meetingId = location.pathname.split("guest/")[1]
            instance.post("/telemedicine/guest/join", {
                user: user,
                meeting_id: meetingId
            })
            .then(response => {
                console.log(response.data);
                navigate("/telemedicine/meeting/guest", { state: response.data })
                setLoading(false)
            })
            .catch(error => {
                console.log(error.response.data);
                setError(error.response.data.message)
                setLoading(false)
            })
        }
    }

    return (
        <div className="h-[100svh] flex justify-center items-center">

            <div className="space-y-4">
                <div className="font-semibold text-[24px]">You've been invited to join a meeting</div>

                <div className="flex flex-col w-[400px] gap-3">
                    <input onChange={e => setUser(e.target.value)} placeholder="Enter your name" className="p-3 bg-[#f1f1f1] rounded-[6px] outline-none" />
                    <button onClick={joinMeeting} disabled={loading} className={`${loading ? "bg-[#00b0ad21]" : "bg-[#00b0ad]"} rounded-[6px] p-3 font-semibold text-white`}>Join Meeting</button>
                </div>

                <div className="text-red-500 text-[14px] font-semibold">{error}</div>
            </div>
        </div>
    )
}